module.exports = __webpack_public_path__ + "media/recipes/24-1ce8db30.png";